import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'jb-article-skeleton',
  templateUrl: './article-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArticleSkeletonComponent {}
